import { dashboard } from 'types';
import { keyBy } from 'es-toolkit/compat';
import { toJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export type PasscodeActionConfigMap = {
  [actionName in dashboard.PasscodeAction]?: dashboard.PasscodeActionConfig;
};

interface State {
  actionConfigMap: PasscodeActionConfigMap;
  passcodesEnabled: boolean;
  isInitialized: boolean;
}

const initialState: State = {
  actionConfigMap: {},
  passcodesEnabled: false,
  isInitialized: false,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.PASSCODE_CONFIG_FETCH_DONE:
    case AppConstants.PASSCODE_CONFIG_UPDATE_DONE: {
      const data = toJSON<dashboard.PasscodeBusinessConfig>(payload);
      return {
        ...state,
        isInitialized: true,
        actionConfigMap: keyBy(data.actionConfig, 'action'),
        passcodesEnabled: data.passcodeMode === 'ENABLED',
      };
    }
    case AppConstants.PASSCODE_CONFIG_FETCH_STARTING:
      return {
        ...state,
        isInitialized: false,
      };
    case AppConstants.PASSCODE_CONFIG_FETCH_FAILED:
      return {
        ...state,
        isInitialized: true,
      };
    default:
      return state;
  }
}
